module.exports = __webpack_public_path__ + "img/checkbox-checked.8143f2dc.svg";